<template>
  <div class="animate-pulse">
    <div
      class="h-3 mt-2 bg-shimmer w-24 rounded ms-4 mb-2 md:ms-0 dark:bg-gray-850"
    ></div>

    <div class="bg-white md:border md:rounded-lg p-4 space-y-3">
      <div class="h-10 bg-shimmer rounded dark:bg-gray-850"></div>
      <div class="h-10 bg-shimmer rounded dark:bg-gray-850"></div>
      <div class="h-10 bg-shimmer rounded dark:bg-gray-850"></div>
      <div class="h-10 bg-shimmer rounded dark:bg-gray-850"></div>
    </div>
  </div>
</template>
